import React from 'react';
import './itp-autoturisme.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';

// Rutele de imagini gata pregătite pentru a fi înlocuite cu fișierele tale locale
const images = {
  mainService: "https://images.pexels.com/photos/8985518/pexels-photo-8985518.jpeg",
  circleServicii: "https://images.pexels.com/photos/8985462/pexels-photo-8985462.jpeg",
  circleActe: "https://images.pexels.com/photos/6720509/pexels-photo-6720509.jpeg",
  specimenCiv: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQh3dKtewGzucwLIleGesRLQF2Xb-8xyqHgupKSn7rcTg&s=10",
  specimenTalon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS12F6VUMk_zIJJdREPghmbG1K6ZieqSozEsW3bJRVHng&s=10",
  specimenRca: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRR0CXj_QI77HvGKk57Gx_IAeSZB9xfh0jMQnGeVGCfZg&s=10",
  specimenCi: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQCwZyY-ux_SBrqQjQDC62lFw7MDXAfDtcRdZbbwP1o9w&s=10"
};

// Iconițe simple, inline, fără dependințe externe
const IconCheck = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 6L9 17l-5-5" />
  </svg>
);

const IconClock = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 3" />
  </svg>
);

const IconShield = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2l8 4v6c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V6l8-4z" />
  </svg>
);

const ItpPage = () => {
  return (
    <div className="itp-layout">

      <Navbar />

      {/* SECTIUNEA 1: ARCUL VIZUAL (Inspirat din imaginea 1) */}
      <section className="section-arch-layout">
        <div className="arch-container">
          <div className="arch-image-side">
            <img
              src={images.mainService}
              alt="Inspectie tehnica periodica auto in service autorizat RAR"
              className="image-arched"
            />
          </div>
          <div className="arch-text-side">
            <span className="badge-seo">
              <span className="itp-eyebrow">Stație ITP autorizată RAR</span>
            </span>
            <h1>ITP Autoturisme Sector 2 București</h1>
            <p>
              Ai nevoie de o verificare rapidă? La <strong>ITP Sector 2</strong> oferim servicii profesionale de
              <strong> inspecție tehnică periodică</strong> pentru toate tipurile de vehicule: benzină, diesel, hibrid sau electrice,
              cu emiterea pe loc a <strong>certificatului ITP</strong> valabil la nivel național.
            </p>
            <p>
              Suntem o stație modernă de <strong>ITP București</strong>, echipată cu aparatură de ultimă generație (stand de frânare,
              analizor de gaze și linie de testare suspensie) și personal autorizat RAR. Dacă ești în căutarea unui serviciu de
              <strong> ITP autoturisme</strong> de încredere, echipa noastră îți garantează o verificare corectă, transparentă și
              rapidă, pentru ca tu să circuli în deplină siguranță și fără bătăi de cap la reînnoirea talonului.
            </p>

            <div className="itp-trust-row">
              <span className="itp-trust-chip"><IconShield /> Autorizare RAR</span>
              <span className="itp-trust-chip"><IconClock /> Rezultat în aceeași vizită</span>
              <span className="itp-trust-chip"><IconCheck /> Preț fix, fără costuri ascunse</span>
            </div>
          </div>
        </div>
      </section>

      {/* SECTIUNEA: PREȚURI ITP AUTOTURISME */}
      <section className="section-prices-layout">
        <div className="prices-header">
          <span className="itp-eyebrow">Tarife 2026</span>
          <h2>Tarife/Prețuri ITP Autoturisme Sector 2</h2>
          <p>Prețuri transparente, fără costuri ascunse. Verificarea tehnică se achită doar dacă testele sunt efectuate conform normelor RAR.</p>
        </div>

        <div className="prices-grid">

          {/* Card 1: Taxi / Ride Sharing */}
          <div className="price-card">
            <div className="price-image-box">
              <img
                src="https://images.pexels.com/photos/30463342/pexels-photo-30463342.jpeg"
                alt="ITP Autoturisme Taxi și Ride Sharing București"
              />
            </div>
            <div className="price-card-content">
              <h3>Autoturisme Taxi / Ride Sharing</h3>
              <p className="price-tag">180 <span>RON</span></p>
              <p className="price-details">Verificare obligatorie la 6 luni pentru transportul de persoane. Include test noxe, frâne și verificarea aparatului de taxat.</p>
              <button className="btn-price-action"><a href="tel:+40726104358">Programează-te</a></button>
            </div>
          </div>

          {/* Card 2: Clasice */}
          <div className="price-card popular">
            <div className="price-image-box">
              <img
                src="https://images.pexels.com/photos/1007410/pexels-photo-1007410.jpeg"
                alt="ITP Autoturisme Clasice și Standard"
              />
            </div>
            <div className="price-card-content">
              <h3>Autoturisme Clasice / Standard</h3>
              <p className="price-tag">200 <span>RON</span></p>
              <p className="price-details">Valabil pentru mașini pe benzină, diesel sau hibrid cu tracțiune simplă (pe o singură punte). Include verificarea sistemului de direcție și suspensie.</p>
              <button className="btn-price-action"><a href="tel:+40726104358">Programează-te</a></button>
            </div>
          </div>

          {/* Card 3: 4x4 / Euro 6 */}
          <div className="price-card">
            <div className="price-image-box">
              <img
                src="https://images.pexels.com/photos/37764836/pexels-photo-37764836.jpeg"
                alt="ITP Autoturisme 4x4 și Euro 6"
              />
            </div>
            <div className="price-card-content">
              <h3>Autoturisme 4x4 / Euro 6</h3>
              <p className="price-tag">230 <span>RON</span></p>
              <p className="price-details">Include testare specială pe standul de frânare pentru tracțiune integrală permanentă și diagnoză eco pentru normele Euro 6.</p>
              <button className="btn-price-action"><a href="tel:+40726104358">Programează-te</a></button>
            </div>
          </div>

        </div>
      </section>

      {/* SECTIUNEA 2: COLOANELE CU IMAGINI ROTUNDE (Inspirat din imaginea 2) */}
      <section className="section-circles-layout">
        <div className="circles-container">

          {/* Coloana Servicii */}
          <div className="circle-card">
            <div className="circle-image-wrapper">
              <img src={images.circleServicii} alt="Servicii ITP Bucuresti" />
            </div>
            <h3>SERVICII</h3>
            <p>
              Societatea noastră este autorizată de către Registrul Auto Român (R.A.R) pentru acoperirea excelentă a clienților din zona
              <strong> ITP Sector 2</strong>, <strong>ITP Sector 1</strong> sau <strong>ITP Sector 3</strong>.
            </p>
            <Link to="/" className="btn-minimal" style={{ textDecoration: 'none', display: 'inline-block' }}>
              Citește mai mult
            </Link>
          </div>

          {/* Coloana Zone / Acte */}
          <div className="circle-card">
            <div className="circle-image-wrapper">
              <img src={images.circleActe} alt="Acte necesare inspectie tehnica" />
            </div>
            <h3>ITP APROAPE DE MINE</h3>
            <p>
              Suntem la doar câteva minute distanță de principalele noduri rutiere: <strong>ITP Colentina</strong>, <strong>ITP Obor</strong>,
              <strong> ITP Pantelimon</strong> și <strong>ITP Electronicii</strong>.
            </p>
            <Link to="/" className="btn-minimal" style={{ textDecoration: 'none', display: 'inline-block' }}>
              Citește mai mult
            </Link>
          </div>

        </div>
      </section>

      {/* SECTIUNEA 3: BANNERUL ALBASTRU ACTE NECESARE (Inspirat din imaginea 3) */}
      <section className="section-documents-banner">
        <h2>Acte necesare :</h2>

        <div className="documents-grid">

          <div className="document-item">
            <img src={images.specimenCiv} alt="Specimen Cartea de Identitate a Vehiculului" />
            <a href="#acte" className="yellow-underline-link">Cartea de Identitate a vehiculului (CIV)</a>
          </div>

          <div className="document-item">
            <img src={images.specimenTalon} alt="Specimen Talon Autoturism" />
            <a href="#acte" className="yellow-underline-link">Talonul (Certificatul de Înmatriculare)</a>
          </div>

          <div className="document-item">
            <img src={images.specimenRca} alt="Specimen Asigurare Auto RCA" />
            <a href="#acte" className="yellow-underline-link">Asigurarea Obligatorie RCA Valabilă</a>
          </div>

          <div className="document-item">
            <img src={images.specimenCi} alt="Specimen Buletin Identitate Sofer" />
            <a href="#acte" className="yellow-underline-link">Actul de Identitate (CI) al șoferului</a>
          </div>

        </div>
      </section>
      <Footer />
    </div>

  );
};

export default ItpPage;